import _Promise from 'babel-runtime/core-js/promise';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import RestService from './RestService';
import logger from 'js-logger';

var DslService = function () {
  function DslService() {
    _classCallCheck(this, DslService);

    this.dslFiles = [];

    this.rest = DslService.initRestService();
    this.dslDefinitions = { 'when': [], 'then': [] }; // arrays of objects with the following properties: rowRegex, replacementFunction
  }

  _createClass(DslService, [{
    key: 'initDslRegExp',
    value: function initDslRegExp() {
      var _this = this;

      return new _Promise(function (resolve, reject) {
        _this.rest.getDSLFiles().then(function (res) {
          _this.dslFiles = res.data;
          _this.loadDslDefinitions('when');
          _this.loadDslDefinitions('then');
          resolve();
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'getDslFiles',
    value: function getDslFiles() {
      return this.dslFiles;
    }
  }, {
    key: 'getReplacementFunctionForRdslrClause',
    value: function getReplacementFunctionForRdslrClause(clauseType, exactRdslrClause) {
      // This function is needed when loading the file to parse the content of each row and match it to existing DSL.
      var largestDslRegex = null;
      var replacementFunction = null;
      this.dslDefinitions[clauseType].forEach(function (regexAndReplacementFunction) {
        var dslRegex = regexAndReplacementFunction.rowRegex;
        if (exactRdslrClause.match(dslRegex)) {
          if (!largestDslRegex || largestDslRegex.length < dslRegex.length) {
            largestDslRegex = dslRegex;
            replacementFunction = regexAndReplacementFunction.replacementFunction;
          }
        }
      });
      return replacementFunction;
    }

    // The following methods are not intended to be used outside this service - like private but in java script ;)

  }, {
    key: 'loadDslDefinitions',
    value: function loadDslDefinitions(selectedClauseType) {
      var dslCauses = this.getAllDslClausesOfType(selectedClauseType);
      for (var i = 0; i < dslCauses.length; i++) {
        var currentDsl = dslCauses[i];
        var rowRegex = this.getRegexThatIdentifiesDsl(currentDsl);
        this.dslDefinitions[selectedClauseType].push({
          rowRegex: rowRegex,
          replacementFunction: this.createReplacementFunctionFor(rowRegex, currentDsl)
        });
      }
    }
  }, {
    key: 'getRegexThatIdentifiesDsl',
    value: function getRegexThatIdentifiesDsl(dslString) {
      // Replace the '{<anything>}' by '(?:.*)' and add ^ in the begin.
      var regex = /{(?:.*?)}/g;
      var replacement = '(.*)';
      return '^' + dslString.replace(regex, replacement) + '$';
    }
  }, {
    key: 'createReplacementFunctionFor',
    value: function createReplacementFunctionFor(dslRegex, currentDsl) {
      // This returns a function that will return given exactRdslrClause split by the variable parts into an array,
      // and the variable parts will be replaced by '$input-<inputCounter>$'.
      // Also the variable parts values will be added to the clauseInputs.$input-<inputCounter>$" by calling the given callback (seClauseInputRowAndIncrementTheCounter)
      // Parameter exactRdslrClause of this function is exact rdslr or dsl clause that needs to be replaced.
      // The getInputCounter also needs to be a callback, because will be called in a loop. If it was fixed value, it would lead to incorrect behavior for clauses with multiple inputs.
      var vm = this;
      return function (exactRdslrClause, seClauseInputRowAndIncrementTheCounter, getInputCounter) {
        var matches = exactRdslrClause.match(dslRegex); // those matches will contain all the variable parts of the exactRdslrClause
        var outSplitClause = [];
        if (matches && matches.length > 1) {
          vm.splitTheClauseAndFillClauseInputs(matches, exactRdslrClause, outSplitClause, currentDsl, seClauseInputRowAndIncrementTheCounter, getInputCounter);
        } else {
          logger.info('INFO: No variable part was found for this rdslrClause: ' + exactRdslrClause);
          return exactRdslrClause;
        }
        return outSplitClause;
      };
    }
  }, {
    key: 'splitTheClauseAndFillClauseInputs',
    value: function splitTheClauseAndFillClauseInputs(matches, exactRdslrClause, outSplitClause, currentDsl, seClauseInputRowAndIncrementTheCounter, getInputCounter) {
      var rdslrFromIndex = 0;
      var clauseVariablesCounter = 0;
      for (var i = 1; i < matches.length; i++) {
        // this iterates from 1 not from 0. The first element is the whole match.
        clauseVariablesCounter++;
        var startOfParameter = exactRdslrClause.indexOf(matches[i], rdslrFromIndex);
        if (startOfParameter !== rdslrFromIndex) {
          // The parameter is not in the very beginning of the clause (or just after another parameter).
          outSplitClause.push(exactRdslrClause.substring(rdslrFromIndex, startOfParameter)); // the static part of the rdlsr
        }
        rdslrFromIndex += startOfParameter + matches[i].length;
        var replacementStr = '$input-' + getInputCounter() + '$';
        outSplitClause.push(replacementStr); // the variable part of the rdlsr

        var validationRegex = this.getValidationRegex(currentDsl, clauseVariablesCounter);
        seClauseInputRowAndIncrementTheCounter(replacementStr, matches[i], validationRegex);
      }
      if (rdslrFromIndex < exactRdslrClause.length - 1) {
        // still there is some non-empty static part after the last variable
        outSplitClause.push(exactRdslrClause.substring(rdslrFromIndex)); // put everything till the end of the exactRdslrClause
      }
    }
  }, {
    key: 'getValidationRegex',
    value: function getValidationRegex(currentDsl, clauseVariablesCounter) {
      var dslVariableRegex = /{([^}]*)}/g;
      var dslValidationRegex = /([^:]+)(?=})/g;
      var matches = currentDsl.match(dslVariableRegex);
      var dslVariableDefinition = matches[clauseVariablesCounter - 1];
      return dslVariableDefinition.includes(':') > 0 ? dslVariableDefinition.match(dslValidationRegex)[0] : null;
    }
  }, {
    key: 'getAllDslClausesOfType',
    value: function getAllDslClausesOfType(selectedClause) {
      // selectedClause is 'when' or 'then'
      var splitter = new RegExp('[\\r\\n]');
      var clausesTmp = [];
      this.dslFiles.forEach(function (file) {
        var dslRows = file.content.split(splitter).map(function (row) {
          return row.trim();
        }).filter(function (row) {
          return row !== '';
        }); // filter out empty rows
        clausesTmp = clausesTmp.concat(dslRows);
      });
      return this.extractClauseToArray(clausesTmp, selectedClause);
    }
  }, {
    key: 'extractClauseToArray',
    value: function extractClauseToArray(allClauses, clauseType) {
      var clausePrefix = '[' + clauseType + ']';
      var endBefore = '=';
      return allClauses.filter(function (row) {
        return row.startsWith(clausePrefix);
      }).map(function (row) {
        return row.substring(clausePrefix.length, row.indexOf(endBefore)).trim();
      });
    }
  }], [{
    key: 'initRestService',
    value: function initRestService() {
      return new RestService();
    }
  }]);

  return DslService;
}();

export default DslService;


// WEBPACK FOOTER //
// ./src/service/DslService.js